import React from 'react';
import { TrashIcon } from 'assets/icons';
import Select from './select';
import Table from './table';
import Tooltip from './tooltip';

interface Area {
  id: number;
  name: string;
}

interface Props {
  areas: Area[];
  userAreas: number[];
  onChange: (updatedAreas: number[]) => void;
  labelSelect?: string;
  labelTable?: string;
  splitLayout?: boolean;
}

interface State {
  bottom_sheet_visible: boolean;
  area_search: string;
}

class AreaSelector extends React.Component<Props, State> {
  static defaultProps = {
    labelSelect: 'Haz clic en un tipo de derecho para agregarlo a tu perfil',
    labelTable: 'Tipo de derecho agregado',
  };

  state: State = {
    bottom_sheet_visible: false,
    area_search: '',
  };

  // Áreas disponibles: excluye las que ya fueron seleccionadas
  get availableAreas(): Area[] {
    return this.props.areas.filter((i) => this.props.userAreas.indexOf(i.id) === -1);
  }

  // Áreas filtradas por el buscador del bottom sheet
  get filteredAreas(): Area[] {
    return this.availableAreas.filter((i) =>
      i.name.toLowerCase().includes(this.state.area_search.toLowerCase()),
    );
  }

  addArea = (id: number) => {
    const updated = [...this.props.userAreas, id];
    this.props.onChange(updated);
  };

  removeArea = (index: number) => {
    const updated = [...this.props.userAreas];
    updated.splice(index, 1);
    this.props.onChange(updated);
  };

  openSheet = () => {
    this.setState({ bottom_sheet_visible: true, area_search: '' });
  };

  closeSheet = () => {
    this.setState({ bottom_sheet_visible: false });
  };

  render() {
    const { areas, userAreas, labelSelect, labelTable, splitLayout } = this.props;
    const { bottom_sheet_visible, area_search } = this.state;

    return (
      <div className={`area-selector ${splitLayout ? 'row' : ''}`}>
        <div className={splitLayout ? 'col-md-6' : ''}>
          {/* ── DESKTOP: select nativo ── */}
          <div className='area-selector-desktop'>
            <Select
              color='white'
              label={labelSelect}
              name='area_id'
              value=''
              onChange={(e: any) => {
                const id = parseInt(e.target.value, 10);
                if (id) this.addArea(id);
              }}
              options={this.availableAreas.map((item: Area) => ({
                value: item.id.toString(),
                label: item.name,
              }))}
            />
          </div>

          {/* ── MÓVIL: botón activador + bottom sheet ── */}
          <div className='area-selector-mobile'>
            <label className='area-selector-label'>{labelSelect}</label>
            <button type='button' className='area-selector-trigger' onClick={this.openSheet}>
              <span>Seleccione</span>
              <span className='area-selector-arrow'>&#8250;</span>
            </button>

            {bottom_sheet_visible && (
              <>
                <div className='bottom-sheet-overlay' onClick={this.closeSheet} />
                <div className='bottom-sheet'>
                  <div className='bottom-sheet-header'>
                    <p>Tipo de derecho</p>
                    <button type='button' className='bottom-sheet-close' onClick={this.closeSheet}>
                      &#10005;
                    </button>
                  </div>
                  <div className='bottom-sheet-search-container'>
                    <input
                      className='bottom-sheet-search'
                      type='text'
                      placeholder='Buscar...'
                      value={area_search}
                      onChange={(e) => this.setState({ area_search: e.target.value })}
                    />
                  </div>
                  <div className='bottom-sheet-list'>
                    {this.filteredAreas.length === 0 ? (
                      <p className='bottom-sheet-empty'>Sin resultados</p>
                    ) : (
                      this.filteredAreas.map((item) => (
                        <button
                          key={item.id}
                          type='button'
                          className='bottom-sheet-option'
                          onClick={() => {
                            this.addArea(item.id);
                            this.closeSheet();
                          }}
                        >
                          {item.name}
                        </button>
                      ))
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {userAreas.length > 0 && (
          <div className={splitLayout ? 'col-md-12 mt-3' : 'mt-3'}>
            <div className='container-chips'>
              {userAreas.map((item: any, index: number) => {
                const area: any = areas.find((i: any) => i.id == item);
                return (
                  <div className='chip' key={index}>
                    <span>{area?.name}</span>
                    <a
                      href='#'
                      onClick={(e: any) => {
                        e.preventDefault();
                        this.removeArea(index);
                      }}
                    >
                      ✕
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AreaSelector;
